import Journey from '@models/Journey'

export const getJourneyById = (id) => {
  return Journey.query()
    .withAll()
    .whereIdIn([id])
    .first()
}

export const getInDepthJourneyById = (id) => {
  return Journey.query()
    .withAllRecursive()
    .whereIdIn([id])
    .first()
}

export const getJourneysByIds = (ids) => {
  return Journey.query()
    .withAll()
    .whereIdIn(ids)
    .get()
}

export const getInDepthJourneysByIds = (ids) => {
  return Journey.query()
    .withAllRecursive()
    .whereIdIn(ids)
    .get()
}
